/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/07/2025 17:18
 *
 */

import { PreferencesPathTypeEnum } from '../enum/preferences-path-type.enum';
import { PreferencesReportTypeEnum } from '../enum/preferences-report-type.enum';

const SPEED_AND_COLOR_DEFAULT = [
  { speed: 0, color: '#48CFAD' },
  { speed: 50, color: '#FFCE54' },
  { speed: 90, color: '#FC6E51' },
  { speed: 130, color: '#ED5565' },
  { speed: 140, color: '#2F373A' },
];

export const SETTINGS_DEFAULT_VALUES = {
  'preferences-gmaps-theme': 'MAP_008',
  'preferences-marker-size': 1,
  'preferences-refresh-speed': 60,
  'preferences-path-type': PreferencesPathTypeEnum.directionPath,
  'preferences-report-type': PreferencesReportTypeEnum.report,
  'preferences-speed-and-color': SPEED_AND_COLOR_DEFAULT,
  'preferences-blackbox-info-window': ['labelDriver'],
  'preferences-materials-info-window': ['label'],
  'preferences-sites-info-window': ['label'],
  'company-presets': [],
  'preferences-zoom': 15,
  'preferences-report-dialog-type': 'default',
  'preferences-map-options-clustered': false,
  'preferences-map-options-control': 'roadmap',
  'preferences-map-options-traffic': false,
};

export const CARTOGRAPHY_FOLDER_ID = 'FOLDER-CARTOGRAPHY';
